<template>
    <div>
        <div class="row">
            <div
                v-for="(vehiculo, index) in inventario"
                :key="index"
                class="col-md-4 col-sm-6"
            >
                <div class="featured-car-list">
                    <a :href="`/ficha_tecnica/${vehiculo._id}`">
                        <div class="featured-car-img">
                            <b-carousel
                                :id="'carousel-car-recents' + index"
                                controls
                                indicators
                                fade
                                :interval="false"
                            >
                                <b-carousel-slide
                                    :img-src="
                                        rotate_image(
                                            vehiculo.fotos.foto_principal
                                        )
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_costado_izq
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_diagonal
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_trasera
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_diagonal_2
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_costado_der
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_costado_der_2
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_frontal
                                    "
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            vehiculo.fotos.foto_tablero
                                    "
                                ></b-carousel-slide>
                            </b-carousel>
                        </div>
                        <div class="featured-car-content">
                            <h6 class="mb-0 text-white">
                                <a
                                    :href="`/ficha_tecnica/${vehiculo._id}`"
                                    class="text-uppercase font-weight-light"
                                    >{{ vehiculo.marca }}
                                    {{ vehiculo.linea }}</a
                                >
                            </h6>
                            <h6
                                class="mb-0 text-uppercase text-white"
                                id="text-version"
                            >
                                <small>{{ vehiculo.version }}</small>
                            </h6>
                            <h5
                                class="mb-0 text-white"
                                v-if="
                                    !vehiculo.precio_feria ||
                                        vehiculo.precio_feria == 0 ||
                                        vehiculo.precio_feria == vehiculo.precio
                                "
                            >
                                {{ vehiculo.precio | formatNumber }}
                            </h5>
                            <h5 v-else class="mb-0 text-white">
                                {{ vehiculo.precio_feria | formatNumber }}
                                <small class="text-danger"> Antes :</small>
                                <span class="tachado">
                                    ${{ vehiculo.precio | formatNumber }}
                                </span>
                            </h5>
                            <div class="">
                                <ul class="p-0  m-0">
                                    <li class="text-center">
                                        <b-badge variant="light">{{
                                            vehiculo.modelo
                                        }}</b-badge>
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                vehiculo.kilometraje
                                                    | formatNumber
                                            }}km</b-badge
                                        >
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                get_tipo_caja(vehiculo.caja)
                                            }}</b-badge
                                        >
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                vehiculo.clindraje
                                                    | formatNumber
                                            }}cc</b-badge
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </a>
                </div>

                <!-- <div class="product-listing-m">
                    <div class="product-listing-img">
                        <a :href="`/ficha_tecnica/${vehiculo._id}?type=sellIn`">
                            <img
                                :src="
                                    rotate_image(vehiculo.fotos.foto_principal)
                                "
                                class="img-fluid"
                                alt="image"
                            />
                        </a>
                        <div class="label_icon">
                            $ {{ vehiculo.precio | formatNumber }}
                        </div>
                        <div
                            v-if="vehiculo.peritaje"
                            class="i-shield"
                            data-toggle="tooltip"
                            data-html="true"
                            title="<em>Vehículo</em> <b>PERITADO</b>"
                        >
                            <i class="fa fa-shield" aria-hidden="true" id="icon-shield"></i>
                        </div>
                    </div>
                    <div class="product-listing-content">
                        <h5 class="a-title">
                            <a :href="`/ficha_tecnica/${vehiculo._id}?type=sellIn`">
                                {{ vehiculo.marca }}
                                {{ vehiculo.linea }}
                            </a>
                        </h5>
                        <p class="list-price">
                            {{ vehiculo.modelo }}
                            |
                            {{ get_tipo_caja(vehiculo.caja) }}
                            |
                            {{ vehiculo.clindraje | formatNumber }}
                            cc |
                            {{ vehiculo.kilometraje | formatNumber }}
                            km
                        </p>

                    <ul class="features_list">
                            <li>
                                <i
                                    class="fa fa-tachometer"
                                    aria-hidden="true"
                                ></i>
                                {{ get_combustible(vehiculo.combustible) }}
                            </li>

                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="row">
            <div class="pagination" style="width: 100%;">
                <b-pagination
                    pills
                    v-model="links.current_page"
                    :total-rows="links.total"
                    :per-page="links.per_page"
                    aria-controls="my-table"
                    @change="goPage"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
$(function() {
    $('[data-toggle="tooltip"]').tooltip();
});
export default {
    computed: {
        ...mapFields("buscador", ["inventario", "links"])
    },
    data: () => ({
        vehiculos: []
    }),
    methods: {
        goPage(val) {
            // console.log(">>>>", val);
            window.location.href = "/compra_de_usados?page=" + val;
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        },
        rotate_image(id_image) {
            return (
                "https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/" +
                id_image
            );
        }
    }
};
</script>

<style lang="scss">
.featured-car-img {
    position: relative;
    overflow: hidden;
    // height: 320px !important;
}
.featured-car-img img {
    width: 100%;
    height: 320px !important;
    object-fit: cover;
    display: block;
}

.listing-meta {
    border-bottom: 1px solid #e7e6e6;
}
.label_icon {
    font-size: 25px !important;
}
.featured-listing-wrap ul {
    padding: 0;
    margin: 0 auto 5px !important;
}
.featured-car-content {
    padding: 10px 10px 0px;
    overflow: hidden;
    background: #161616;
    margin-bottom: 30px !important;
    box-shadow: rgb(73 72 71) 0 1px 10px;
}

.featured-car-content li {
    float: left;
    font-size: 13px;
    list-style: outside none none;
    margin-bottom: 0px;
    width: 25%;
}
.featured-car-content a {
    color: #ffffff;
    font-size: 16px;
}

.featured-car-content ul {
    border-top: 1px solid #3a3737 !important;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    padding: 20px 0 20px 0;
}

.featured-listing-wrap h4 {
    margin: 0 auto 6px;
    font-size: 18px;
}
.badge-light {
    color: #222222;
    font-weight: 100;
    background-color: #eaeaea;
}
span.badge.badge-light {
    font-size: 15px;
    color: #ffffff;
    font-weight: 100;
    background-color: #ffffff00;
}
h6#text-version {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
}
.badge {
    padding: 0 !important;
}
span.tachado {
    text-decoration: line-through;
    font-size: 16px;
    color: #fa2837 !important;
}
/* .grid_listing .product-listing-content h5 {
    line-height: 26px;
    margin: 0 auto 20px;
    font-size: 16px;
    margin-bottom: 0px;
}
.label_icon {
    font-size: 20px !important;
}

p.list-price {
    font-size: 14px !important;
    color: #424242 !important;
    font-weight: 500 !important;
}

.grid_listing .product-listing-content {
    padding: 10px 10px 0;
}

ul.features_list {
    margin-top: 0px !important;
}

ul.features_list > li {
    text-align: center;
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #d3d3d3;
    border-color: #d3d3d3;
}

.page-link {
    color: #161a1d;
}
.i-shield {
    background: #000000d6;
    color: #ffffff;
    padding: 0 5px;
    position: absolute;
    top: 10px;
    left: 10px;
}
i#icon-shield {
    text-shadow: -2px 3px 4px #000000;
    font-size: 23px;
}
h6#text-version {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
} */
</style>
